import { useCreateQueryKeys as e } from "@maat/store-hooks";
//#region src/propertyDrafts/propertyDraftQueryKeys.ts
var t = e("propertyDrafts", {
	list: () => ["list"],
	detail: (e) => ["detail", e]
});
//#endregion
export { t as propertyDraftQueryKeys };
